import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api/google-oauth`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('handleey_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('handleey_token');
      localStorage.removeItem('handleey_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export const googleOAuthApi = {
  getAdminConfig: () => api.get('/admin/config'),
  updateAdminConfig: (data) => api.put('/admin/config', data),
  getStatus: (params) => api.get('/status', { params }),
  getAuthorizeUrl: (params) => api.get('/authorize-url', { params }),
  handleCallback: (params) => api.post('/callback', null, { params }),
  getLocations: (params) => api.get('/locations', { params }),
  selectLocation: (data, params) => api.post('/select-location', data, { params }),
  refresh: (params) => api.post('/refresh', null, { params }),
  disconnect: (params) => api.post('/disconnect', null, { params }),
};

export default googleOAuthApi;
